/**
 * MFA API Client
 *
 * Client-side API functions for Multi-Factor Authentication.
 * All calls proxy through apps/api — frontend never touches Cognito directly.
 *
 * Endpoints live at /api/v1/auth/mfa/* (registered in auth routes.js).
 *
 * Epic: MVP 1.15 (V2) — Federated Auth, Epic 4: MFA
 * Story: SCRUM-356 — Guide MFA Setup
 */

import apiRequest from './api';

export const mfaApi = {
  /**
   * Initiate TOTP setup.
   * Returns { data: { secret, qrCode, backupCodes } }
   */
  async initiateSetup() {
    return apiRequest('/api/v1/auth/mfa/setup', { method: 'POST' });
  },

  /**
   * Verify TOTP code to activate MFA.
   * @param {string} code - 6-digit TOTP code from authenticator app
   */
  async verifySetup(code) {
    return apiRequest('/api/v1/auth/mfa/verify', {
      method: 'POST',
      body: { code },
    });
  },

  /**
   * Disable all MFA for the authenticated user.
   * Requires password confirmation.
   * @param {string} password - User's current password
   */
  async disable(password) {
    return apiRequest('/api/v1/auth/mfa/disable', {
      method: 'POST',
      body: { password },
    });
  },

  /**
   * Get current MFA status.
   * Returns { data: { mfaEnabled: boolean, mfaMethod: string|null } }
   */
  async getStatus() {
    return apiRequest('/api/v1/auth/mfa/status', { method: 'GET' });
  },
};
